import { researchStatus } from '@/enums/researchStatus'
import axiosInstance from '@/service/helpers/axios'
import { type AxiosResponse } from 'axios'

export async function getCommunityResearchList(
  page: number = 1,
  limit: number = 10,
  sortdesc: string,
  status: researchStatus,
  query: string = ''
): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/circle-research/circle/list', {
    params: { page, limit, sortdesc, status, query }
  })
  return result
}

export async function submitRequestResearch(
  body: {
    status: string | undefined
    notes: string | undefined
  },
  researchId: number
) {
  const result = await axiosInstance.put(
    `/circle-research/circle/response-approval/${researchId}`,
    body
  )
  
  return result
}

export async function getCommunityResearchPreviewById(
  researchId: number = 1
): Promise<AxiosResponse> {
  const result = await axiosInstance.get(`/circle-research/circle/preview/${researchId}`)
  return result
}

export async function getCommunityFirstContentById(researchId: number = 1): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `/circle-research/circle/first-content/${researchId}`
  )
  return result
}

export async function getCommunitySecondContentById(
  researchId: number = 1
): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `/circle-research/circle/second-content/${researchId}`
  )
  return result
}

export async function softDeleteCommunityResearch(researchId: number) {
  const result = await axiosInstance.delete(`/circle-research/circle/delete/${researchId}`)
  
  return result
}
export async function restoreCommunityResearch(researchId: number) {
  const result = await axiosInstance.get(`/circle-research/circle/restore/${researchId}`)
  
  return result
}

export async function getLogsHistoryCommunityResearch(researchId: number) {
  const result = await axiosInstance.get('/circle-research/logs/history/' + researchId)
  
  return result
}

export async function getTotalRequestCommunityResearch() {
  const result = await axiosInstance.get('/circle-research/circle/data/total-request')
  
  return result
}
